<template>
  <div class="row" v-if="can_access('email','view')">
    <div class="col-md-12" style="display: block ruby;">
		  <h1 class="">Email Server</h1>
    </div>
    <div class="col-md-12">
      <TableView :col="columns" :getData="getData" v-if="can_access('email','view') && emailTableView"/>
    </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import common from '@/assets/js/common.js';
import TableView from '@/components/Common/DataTable/Table';

export default {
  name: 'EmailServer',
  components: { Widget, TableView },
  mixins: [common],
  data() {
    return {
      emailTableView: true,
      errorMessage: null,
      columns: (() => {
        const cols = [
          { title: 'Subject', field: 'subject', thComp: 'FilterTh', sortable: true, visible: 'true' },
          { title: 'From Name', field: 'from_name', thComp: 'FilterTh' },
          { title: 'From Email', field: 'from', thComp: 'FilterTh', tdStyle: { fontStyle: 'italic' } },
          { title: 'To Name', field: 'to_name', thComp: 'FilterTh', thStyle: { fontWeight: 'normal' } },
          { title: 'To Email', field: 'to', thComp: 'FilterTh', tdComp: 'Email'},
          { title: 'Sent Date', field: 'sent_date', thComp: 'FilterTh'},
          { title: 'Operation', tdComp: 'emailOpt', visible: 'true', tdStyle:{'text-align':'center'}, thStyle:{'text-align':'center'} }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('email', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  methods: {
    emailReRender(response) {
      if(response.code==0){
        this.emailTableView = false;
        this.$nextTick(function(){
          this.emailTableView = true;
          this.$toasted.success("Successfully Sent",{duration:1000});
        });
      }
    },
    async getData(query, filter) {
      var { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });

      let uri = 'get_sent_email?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    }
  },
  created() {
    
  },
};
</script>